import { SplashView } from "@/components/ui/splash-view";

/**
 * Entry route. The navigation guard in the root layout immediately redirects
 * to the correct group, so this only ever shows for a frame — and it shows the
 * same launch artwork as everything before it, so that frame is invisible
 * rather than a flash of a differently-drawn logo.
 */
export default function Index() {
  return <SplashView />;
}
